import { today, tomorrow } from "@website/utils/date-format";
import toString from "lodash-es/toString";
import type { NextPage } from "next";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { PopularCityPropertiesType } from "./index.type";

const PopularCity: NextPage<PopularCityPropertiesType> = (properties) => {
  const { item } = properties;
  const router = useRouter();

  const renderHref = useCallback((item) => item.href, []);

  const handleRedirectToHotelPage = useCallback(
    () =>
      router.push({
        pathname: renderHref(item),
        query: {
          date_from: toString(today()),
          date_to: toString(tomorrow()),
          ...router.query
        }
      }),
    [item, renderHref, router]
  );

  return (
    <div className="cursor-pointer" onClick={handleRedirectToHotelPage}>
      <div className="flex flex-col gap-4">
        <img
          alt={item.alt}
          className="h-[248px] overflow-hidden rounded-[18px] object-cover"
          height={item.height}
          src={item.image}
          width={item.width}
        />
        <div className="text-on-surface-high-emphasis text-center text-[24px] font-[500]">
          {item.state}
        </div>
      </div>
    </div>
  );
};

export default PopularCity;
